import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { isEmail } from "@utils/regex";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { MailIcon } from "@ui/components/icons";
import { useForm } from "@ui/components/inputs/hooks";
import { SimpleTextInput } from "@ui/components/inputs/simpleTextInput";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap } from "@ui/styles/utils";
import { createToast } from "@ui/toasts/utils";

interface LostPasswordModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}
export const LostPasswordModal: React.FC<LostPasswordModalProps> = ({ close, ...htmlProps }) => {
	const { fieldProps, checkSubmit, formValue } = useForm({ email: "" }, ["email"], { email: isEmail });
	const { currentProfileService } = useServices();

	return (
		<Container lightTitle title={I18n.t("password.forgotten.title")} close={close} {...htmlProps}>
			<Infos>{I18n.t("password.forgotten.infos")}</Infos>
			<FormContainer
				onSubmit={(e) => {
					e.preventDefault();
					if (!checkSubmit()) {
						return;
					}
					currentProfileService.sendRecoveryEmail(formValue.email);
					createToast(I18n.t("success"), I18n.t("password.forgotten.sent"), "success");
					close();
				}}
			>
				<SimpleTextInput
					icon={<MailIcon />}
					iconPosition="left"
					type="email"
					{...fieldProps("email")}
					placeholder={I18n.t("email.placeholder")}
				/>
				<PrimaryButton type="submit">{I18n.t("password.forgotten.button")}</PrimaryButton>
			</FormContainer>
		</Container>
	);
};

const Container = styled(ClosableModal)``;

const Infos = styled.div`
	${({ theme }) => theme.textStyles.title};
	margin: 20px 0 35px;
`;

const FormContainer = styled.form`
	${gap(60)}
	.input-wrapper > svg .main-path {
		fill: ${({ theme }) => theme.colors.primary};
	}
`;
